<template>
  <div class="hello" style="height: 100vh;" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <GlobalHeader style="position: absolute;" :activeIndex="activeIndex" />
    <el-main>
      <div style="position: fixed;z-index: 111; background: #fff;width: calc(100% - 175px); min-width:1200px">
        <div class="edit">
          <div class="fl" style="justify-content: space-between; margin-left: 6px">
            <span style="width: 63px; background-color: #589ff9"  @click="openChildDialog(1)">
              <img src="../../images/increase.png" style="width: 15px; height: 15px" alt="" />
            </span>
            <span style="width: 69px;" @click="cleanUpEvt">ALL</span>
          </div>

          <el-tooltip class="item" effect="dark" content="支出ID" placement="bottom">
            <el-input placeholder="支出ID" v-model="id" clearable @change="getList"
              :class="{ 'vip': id && id.length != '0' }">
            </el-input>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="支付状态" placement="bottom">
            <el-select v-model="status" filterable placeholder="支付状态" @change="staffChange" style="margin-left: 6px;"
              clearable :class="{ 'vip': status && status !== '支付状态' }">
              <el-option v-for="(value, key) in status_one" :key="key" :label="value" :value="key">
              </el-option>
            </el-select>
          </el-tooltip>

          <el-tooltip class="item" effect="dark" content="报销人" placement="bottom">
            <el-select v-model="settlement" filterable placeholder="报销人" @change="settlementChange" style="margin-left: 6px;"
              clearable :class="{ 'vip': settlement && settlement !== '报销人' }">
              <el-option v-for="(item, index) in settlement_one" :key="index" :label="item.name" :value="item.settlement_id">
              </el-option>
            </el-select>
          </el-tooltip>


          <el-tooltip class="item" effect="dark" content="货币单位" placement="bottom">
            <el-select v-model="currency" filterable placeholder="货币单位" @change="currencyChange" style="margin-left: 6px;"
                clearable :class="{ 'vip': currency && currency !== '货币单位' }">
                <el-option v-for="(item, index) in currency_one" :key="index" :label="item.name" :value="item.currency_id">
                </el-option>
              </el-select>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="结算部门" placement="bottom">
              <el-select v-model="department" filterable placeholder="结算部门" @change="departmentChange" style="margin-left: 6px;"
                  clearable :class="{ 'vip': department && department !== '结算部门' }">
                  <el-option v-for="(item, index) in department_one" :key="index" :label="item.value_1" :value="item.department_id">
                  </el-option>
                </el-select>
          </el-tooltip>

          <el-tooltip class="item" effect="dark" content="支出大类" placement="bottom">
            <el-select v-model="type" filterable placeholder="支出大类" @change="typeChange" style="margin-left: 6px;"
              clearable :class="{ 'vip': type && type !== '支出大类' }">
              <el-option v-for="(item, index) in type_one" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-tooltip>

          <el-tooltip class="item" effect="dark" content="支出小类" placement="bottom">
              <el-select v-model="type_ch" filterable placeholder="支出小类" @change="type_chChange" style="margin-left: 6px;"
                clearable  :class="{ 'vip': type_ch && type_ch !== '支出小类' }" >
               <el-option v-for="(item, index) in type_ch_one" :key="index" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-tooltip>

          <el-tooltip class="item" effect="dark" content="申请时间" placement="bottom">
            <el-date-picker v-model="value0" style="width: 137px;margin-left: 6px;" type="daterange"
              :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" range-separator="" start-placeholder="申请时间"
              align="right" :class="{ 'your-css-class_box': !isValue3Empty_1 }" value-format="timestamp"
              @change="getList">
            </el-date-picker>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="支出时间" placement="bottom">
            <el-date-picker v-model="value1" style="width: 137px;margin-left: 6px;" type="daterange"
              :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" range-separator="" start-placeholder="支出时间"
              align="right" :class="{ 'your-css-class_box': !isValue3Empty_2 }" value-format="timestamp"
              @change="getList">
            </el-date-picker>
          </el-tooltip>

          <el-tooltip class="item" effect="dark" content="结算时间" placement="bottom">
              <el-date-picker v-model="value2" style="width: 137px;margin-left: 6px;" type="daterange"
                :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" range-separator="" start-placeholder="结算时间"
                align="right" :class="{ 'your-css-class_box': !isValue3Empty_3}" value-format="timestamp"
                @change="getList">
              </el-date-picker>
            </el-tooltip>

          <el-tooltip class="item" effect="dark" content="银行" placement="bottom">
                <el-select v-model="bank" filterable placeholder="银行" @change="bankChange" style="margin-left: 6px;"
                  clearable :class="{ 'vip':  bank &&  bank !== '银行' }">
                  <el-option v-for="(value, key) in  bank_one" :key="key" :label="value.name" :value="value.bank_account_id">
                  </el-option>
                </el-select>
            </el-tooltip>

          <el-tooltip class="item" effect="dark" content="付款给" placement="bottom">
            <el-input placeholder="付款给" clearable  v-model="payto_name" @change="getList"
             :class="{ 'vip': payto_name && payto_name.length != '0' }"></el-input>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="备注" placement="bottom">
            <el-input placeholder="备注" clearable v-model="remark"  @change="getList"
             :class="{ 'vip': remark && remark.length != '0' }"></el-input>
          </el-tooltip>


          <span style="margin-left: 5px" @click="excelEvt">EXCEL</span>
        </div>
        <div class="pagination_box">
          <el-input v-model="paginationInput" style="width: 50px" size="mini" placeholder="To"
            @change="limitEvt"></el-input>
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage1"
            :page-size="paginationInput - 0" layout="prev, pager, next, jumper" :total="total" :pager-count="5">
          </el-pagination>
        </div>
        <div style="width: 100%">
          <span class="span_box">{{total}}</span>
          <el-tabs>
            <el-tab-pane label="基本信息">
              <el-table :data="tableData" ref="sortTable" height="55%" border @sort-change="sortChangeEvt"  @cell-mouse-enter="huaguo" @cell-click="idEvt"
                 :summary-method="getSummariesEvt" show-summary   v-sort-orders="['descending', 'ascending', '']"  >
                <el-table-column prop="id" label="ID" sortable="custom" width="90" align="left"  >
                    <template slot-scope="props">
                        <span @click="openChildDialog(2)"  >{{ props.row.id }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="out_status" sortable="custom" label="支付状态" width="100">
                     <template slot-scope="props">
                              <span style="color:#589ff9" v-if="props.row.out_status === 1">申请中</span>
                              <span  v-else-if="props.row.out_status === 2">支付完毕</span>
                    </template>
                </el-table-column>
                <el-table-column prop="settlement_name" sortable="custom" label="报销人" width="120">
                </el-table-column>
                <el-table-column prop="amount" sortable="custom" label="支出金额" width="120">
                </el-table-column>
                <el-table-column prop="currency_name" sortable="custom" label="货币单位" width="120">
                </el-table-column>
                <el-table-column prop="converted_amount" sortable="custom" label="支出折算" width="120"   class-name="project_three">
                </el-table-column>
                <el-table-column prop="bm_name" sortable="custom" label="结算部门" width="120" class-name="project_one">
                  <template slot-scope="props">
                    <span class="white_over">{{ props.row.bm_name }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="type_name" label="支出大类" sortable="custom" width="120" class-name="project_one">
                </el-table-column>
                <el-table-column prop="type_ch_name" sortable="custom" label="支出小类" width="120" class-name="project_one">
                </el-table-column>
                <el-table-column prop="apply_time" label="申请时间" sortable="custom" width="100" class-name="project_two">
                </el-table-column>
                <el-table-column prop="expend_time" sortable="custom" label="支出时间" width="100" class-name="project_two">
                </el-table-column>
                <el-table-column prop="settlement_time" label="结算时间"  width="100"  sortable="custom" class-name="project_two">
                </el-table-column>
                <el-table-column prop="bank_name" label="银行账户"  width="150"  sortable="custom">
                </el-table-column>
                <el-table-column prop="payto_name" label="付款给"  width="100"  sortable="custom">
                </el-table-column>
                <el-table-column prop="remark" label="备注"    sortable="custom">
                  <template slot-scope="props">
                      <span class="white_over">{{ props.row.remark }}</span>
                    </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </el-main>

     <el-dialog
      :visible.sync="dialogVisible"
        width="1090px"
      custom-class="maxss" :top="dialogTop"  >
      <div class="whole">
            <div style="width: 1050px;margin-left: 10px; position: fixed;">
              <div class="cloneEvt">
                <span @click="saveEvt" style="cursor: pointer;">保存</span>
                <span @click="DelEvt"  style="cursor: pointer;">删除</span>
              </div>
              <div style="width: 100%;">
                   <div  style="display: flex;">
                       <el-form ref="form" label-width="75px" size="mini"
                      style="display: flex;flex-direction: column;margin-top: 20px;background: #Fff;border-radius: 5px;justify-content: space-around;width: 360px;">
                        <el-form-item label="ID" style="font-size: 12px;margin-top: 20px">
                          <el-input v-model="ids" readonly style="width: 270px;margin-left: 6px;"></el-input>
                        </el-form-item>
                        <el-form-item label="报销人" style="font-size: 12px;">
                             <el-select v-model="settlement_name" filterable placeholder="报销人" @change="settlement_oneChange" style="width: 270px;margin-left: 6px;"
                            clearable >
                            <el-option v-for="(item, index) in settlement_one" :key="index" :label="item.name" :value="item.settlement_id">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="支出金额" style="font-size: 12px; margin-top: 10px ">
                           <el-input v-model="amount"  style="width: 270px;margin-left: 6px;"></el-input>
                        </el-form-item>
                         <el-form-item label="货币单位" style="font-size: 12px; ">
                            <el-select v-model="currency_name" filterable placeholder="货币单位" @change="currency_oneChange" style="width: 270px;margin-left: 6px;"
                              clearable :class="{ 'vip': currency && currency !== '货币单位' }">
                              <el-option v-for="(item, index) in currency_one" :key="index" :label="item.name" :value="item.currency_id">
                              </el-option>
                            </el-select>
                          </el-form-item>

                           <el-form-item label="申请时间" style="font-size: 12px; ">
                              <el-date-picker v-model="apply_time" style="width:270px;margin-left: 6px;" type="date"
                                :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" range-separator=""
                                placeholder="申请时间" align="right" value-format="timestamp">
                              </el-date-picker>
                            </el-form-item>

                             <el-form-item label="当前汇率" style="font-size: 12px; ">
                               <el-input v-model="exchange_rate" readonly  style="width: 270px;margin-left: 6px;"></el-input>
                            </el-form-item>

                             <el-form-item label="当前支出折算" style="font-size: 12px; ">
                                <el-input v-model="converted_now" readonly  style="width: 270px;margin-left: 6px;"></el-input>
                            </el-form-item>

                             <el-form-item label="结算部门" style="font-size: 12px;">
                                <el-select v-model="department_two" filterable placeholder="结算部门" @change="department_twoChange" style="width: 270px;margin-left: 6px;"
                                  clearable :class="{ 'vip': department && department !== '结算部门' }">
                                  <el-option v-for="(item, index) in department_one" :key="index" :label="item.value_1" :value="item.department_id">
                                  </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="结算时间" style="font-size: 12px;">
                                <el-date-picker v-model="settlement_time" style="width:270px;margin-left: 6px;" type="date"
                                  :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" range-separator=""
                                  placeholder="结算时间" align="right" value-format="timestamp">
                                </el-date-picker>
                              </el-form-item>
                              <el-form-item label="支出大类" style="font-size: 12px; ">
                                   <el-select v-model="type_name" filterable placeholder="支出大类" @change="type_oneChange" style="width: 270px;margin-left: 6px;"
                                      clearable :class="{ 'vip': type && type !== '支出大类' }">
                                      <el-option v-for="(item, index) in type_one" :key="index" :label="item.name" :value="item.id">
                                      </el-option>
                                    </el-select>
                              </el-form-item>
                            <el-form-item label="支出小类" style="font-size: 12px; padding:0px 5px 0px 5px;">
                               <el-select v-model="type_ch_name" filterable placeholder="支出小类" @change="type_ch_oneChange" style="margin-left: 8px;width: 270px;"
                                clearable  >
                                  <el-option v-for="(item, index) in type_ch_one" :key="index" :label="item.name" :value="item.id">
                                </el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item label="付款给" style="font-size: 12px; ">
                                <el-input v-model="payto_names"  style="width: 270px;margin-left: 6px;"></el-input>
                            </el-form-item>

                            <el-form-item label="备注" style="font-size: 12px; padding:0px 10px 0px 0px;">
                              <textarea style="margin-left: 10px;border: 1px solid #e5e5e5;outline: none;"  v-model="remarks" name="" id="" cols="35" rows="5"></textarea>
                            </el-form-item>
                      </el-form>


                    <div style="margin-top: 20px;height:700px;background: #Fff;border-radius: 5px;margin-left: 10px;">
                        <el-form ref="form" label-width="75px" size="mini"
                        style="display: flex;flex-wrap: wrap;justify-content:left;">
                        <el-form-item label="发票类型" style="font-size: 12px;margin-top: 20px;height: 20px;">
                            <el-select v-model="invoice_type" filterable placeholder="支出小类" @change="invoice_typeChange" style="margin-left: 6px;width: 350px;"
                            clearable  >
                              <el-option   v-for="(value, key) in invoice_type_one" :key="key" :label="value" :value="key">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="银行账户" style="font-size: 12px; margin-top: 20px;height: 20px;">
                          <el-select v-model="bank_name" filterable placeholder="银行" @change="bank_nameChange" style="margin-left: 4px;width: 350px;"
                              clearable :class="{ 'vip': bank && bank !== '银行' }">
                              <el-option v-for="(value, key) in  bank_one" :key="key" :label="value.name" :value="value.bank_account_id">
                              </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="支出时间" style="font-size: 12px;height: 20px;margin-top:20px;">
                            <el-date-picker v-model="expend_time" style="width:350px;margin-left: 6px;" type="date"
                              :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" range-separator=""
                              placeholder="支出时间" align="right" value-format="timestamp">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item style="width: 450px;" v-if="selectedId !== '' ? false : true"></el-form-item>
                        <el-form-item style="width: 450px;margin-top: 20px;text-align: left;" v-if="selectedId == '' ? false : true">
                          <span>申请状态</span>
                                <el-radio-group v-model="radio">
                                      <el-radio :label="1">申请中</el-radio>
                                      <el-radio :label="2">支付完毕</el-radio>
                                    </el-radio-group>
                        </el-form-item>
                      </el-form>
                    </div>
                   </div>
              </div>
            </div>

      </div>
    </el-dialog>
  </div>
</template>

<script>
import GlobalHeader from '@/components/GlobalHeader.vue'
import { ERPExpApi , ERPExpTuApi  , InfoApi    , EditTwoApi   ,ExpeDelApi } from "@/api/staff/staff.js"

const delay = (function () {
  let timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();
export default {
  components: {
    GlobalHeader
  },
  data() {
    return {
      activeIndex: "6",
      tableData: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const current = new Date();
              let nowDayOfWeek = current.getDay();
              if (nowDayOfWeek === 0) nowDayOfWeek = 7;
              const dayNum = 1 * 24 * 60 * 60 * 1000;
              const firstDate = new Date(current.valueOf() - (nowDayOfWeek - 1) * dayNum);
              const lastDate = new Date(new Date(firstDate).valueOf() + 6 * dayNum);
              picker.$emit("pick", [firstDate, lastDate]);
            },
          },
          {
            text: "当月",
            onClick(picker) {
              const date = new Date();
              const year = date.getFullYear();
              const month = date.getMonth();
              let thisMonthStartDate = new Date(year, month, 1);
              let thisMonthEndDate = new Date(year, month + 1, 0);
              picker.$emit("pick", [thisMonthStartDate, thisMonthEndDate]);
            },
          },
          {
            text: "当年",
            onClick(picker) {
              var tYear = new Date().getFullYear();
              var startTime = new Date(tYear, 0, 1); //当前年第一天
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, start]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              const current = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000);
              let nowDayOfWeek = current.getDay();
              let diffToMonday =
                current.getDate() - nowDayOfWeek + (nowDayOfWeek === 0 ? -6 : 1);
              const firstDate = new Date(current.setDate(diffToMonday));
              const lastDate = new Date(current.setDate(diffToMonday + 6));
              picker.$emit("pick", [firstDate, lastDate]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              var now = new Date();
              var fd = new Date(now.getFullYear(), now.getMonth() - 1, 1);
              var ed = new Date(now.getFullYear(), now.getMonth(), 0);
              picker.$emit("pick", [fd, ed]);
            },
          },
          {
            text: "去年",
            onClick(picker) {
              var tYear = new Date().getFullYear() - 1;
              var startTime = new Date(tYear, 0, 1);
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            },
          },
        ],
      },
      options1: [{
        value: '1',
        label: '上门拜访',
      }, {
        value: '2',
        label: '网络开发',
      }, {
        value: '3',
        label: '推荐',
      }, {
        value: '4',
        label: '自主上门',
      }],
      options2: [{
        value: '1',
        label: '合作过',
      }, {
        value: '2',
        label: '未合作',
      }, {
        value: '3',
        label: '一年内合作',
      }, {
        value: '4',
        label: '一年内没合作',
      }],
      isValue3Empty_1: true,
      isValue3Empty_2: true,
      isValue3Empty_3: true,

      converted_amount: null,
      status: null,
      //排序
      order: null,
      orField: null,
      status_one: null,
      settlement_one: null,
      type_one: null,
      type: null,
      currency:null,
      currency_one:null,
      type_ch_one:null,
      type_ch:null,
      bank_one:null,
      bank:null,
      payto_name:null,
      remark:null,
      id: null,
      settlement: null,
      bm_name: null,
      amount: null,
      apply_time: null,
      value0: '',
      value1: '',
      value2: '',
      value3: '',

      total: null,
      paginationInput: 95,
      currentPage1: 1,
      totalRow: null,

      dialogVisible: false,
      selectedId:null,
      settlement_name:null,
      ids:null,
      department_one:null,
      department:null,
      department_two:null,
      invoice_type_one:null,
      invoice_type:null,
      type_ch_name:null,
      type_name:null,
      expend_time:null,
      bank_name:null,
      currency_name:null,
      exchange_rate:null,
      converted_now:null,
      settlement_time:null,
      payto_names:null,
      remarks:null,
      radio:1,
      dialogTop: null, // 初始值为1vh
      loading:false
    };
  },
  created() {
    this.loading = true;
    ERPExpApi({}).then((res => {
      this.tableData = res.data;
      this.total = res.total,
      this.currentPage1 = res.page - 0;
      this.totalRow = res.totalRow;
      this.loading=false
    }))

    ERPExpTuApi({}).then((res => {
            this.status_one = res.data.status   //支付状态
            this.settlement_one = res.data.settlement   //报销人
            this.currency_one = res.data.currency   //货币单位
            this.type_one = res.data.type   //支出大类
            this.type_ch_one = res.data.type_ch      //支出小类
            this.bank_one = res.data.bank      //银行
            this.department_one = res.data.department
            this.invoice_type_one = res.data.invoice_type

    }))
  },
  mounted() {
    window.addEventListener("scroll", (e) => this.imgScrollEvt(e), true);
    // 在mounted钩子中监听窗口尺寸变化，根据不同尺寸修改dialogTop的值
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
   beforeDestroy() {
    // 在组件销毁前移除窗口尺寸变化的监听
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
     DelEvt() {
      this.$confirm('是否永久删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ExpeDelApi({
          id: this.selectedId,
        }).then(res => {
          if (res.code == 1000) {
            this.$message({
              type: 'success',
              message: '删除成功'
            });
            this.dialogVisible = false
            this.getList()
          } else {
            alert(res.msg)
          }
        })
      })
    },
    handleResize() {
      // 根据不同的屏幕尺寸设置不同的top值
      if (window.innerWidth <= 1920) {
        this.dialogTop = '8vh'
      } else if (window.innerWidth <= 2560) {
        this.dialogTop = '10vh'
      } else if (window.innerWidth <= 3440) {
        this.dialogTop = '15vh'
      } else if (window.innerWidth <= 3840) {
        this.dialogTop = '20vh'
      }
    },
      huaguo(row, column, cell, event) {
      this.selectedId = row.id
    },
    idEvt(row, column, cell, event) {
      this.selectedId = row.id
    },
    //点击打开弹窗事件
    openChildDialog(type) {
      if (type == 1) {
        this.selectedId = '',
        this.ids = '',
        this.settlement_name = '',
        this.amount = '',
        this.currency_name = '',
        this.apply_time = '', //申请时间
        this.bm_name = '',
        this.invoice_type = '',
        this.radio = '';
        this.department_two = '', //结算部门
        this.exchange_rate = '', //当前汇率
        this.converted_now = '', //当前支出折算
        this.type_name = '', //支出大类
        this.type_ch_name = '',    //支出小类type_ch_id
        this.payto_names = '',   //付款给
        this.remarks = '',//备注
        this.bank_name = '', //银行账户
        this.settlement_time = '',//结算时间
        this.expend_time = '',  //支出时间
        this.dialogVisible = true
      } else if (type == 2) {
        //打开收入管理弹窗详情页
        InfoApi({
          id: this.selectedId
        }).then((res) => {
          if (res.code == 1000) {
              this.ids  = res.data.data.id
              this.settlement_name = res.data.data.settlement_id
              this.amount = res.data.data.amount
              this.currency_name = res.data.data.currency_id
              this.apply_time =  Date.parse(res.data.data.apply_time)  //申请时间
              this.bm_name = res.data.data.bm_name
              this.invoice_type = res.data.data.invoice_type
              this.invoice_type_one = res.data.invoice_type
              this.department_two = res.data.data.department_id //结算部门
              this.exchange_rate = res.data.exchange_rate //当前汇率
              this.converted_now  = res.data.converted_now //当前支出折算
              this.type_name = res.data.data.type_id  //支出大类
              this.type_ch_name = res.data.data.type_ch_id    //支出小类type_ch_id
              this.payto_names= res.data.data.pay_to   //付款给
              this.remarks = res.data.data.remark //备注
              this.bank_name = res.data.data.bank_account_id //银行账户
              this.settlement_time  =  Date.parse(res.data.data.settlement_time) //结算时间
              this.expend_time = Date.parse(res.data.data.expend_time)   //支出时间
              this.radio = res.data.data.out_status
              this.dialogVisible = true
          }
        });
      }
    },
    saveEvt(){
      EditTwoApi({
        id:this.ids,
        settlement_name:this.settlement_name ,
        amount:this.amount ,
        currency_name:this.currency_name ,
        apply_time:this.apply_time /1000 ,
        department_id:this.department_two,
        invoice_type:this.invoice_type ,
        department_two:this.department_two ,
        exchange_rate:this.exchange_rate ,
        converted_now:this.converted_now ,
        type_name:this.type_name ,
        type_ch_name:this.type_ch_name ,
        payto_names:this.payto_names ,
        remarks:this.remarks,
        bank_name:this.bank_name ,
        settlement_time:this.settlement_time /1000,
        expend_time: this.expend_time /1000  ? this.expend_time / 1000 : '',
        out_status:this.radio,
      }).then(res=>{
            if (res.code == 1000) {
                this.dialogVisible  = false;
                this.getList()
            }else{
              if (res.code == 1004) {
                  this.$message(res.msg)
              }
            }
      })
    },


    limitEvt() {
      this.getList();
    },

    showTab(tab) {
      this.activeTab = tab;
    },
    //分页
    handleCurrentChange(res) {
      this.loading = true
      setTimeout(() => {
        this.getList();
        this.loading = false
      }, 100)
    },



    //支付状态
    staffChange(key) {
      this.status = key;
      this.getList()
    },
    //货币单位
    currencyChange(key){
        this.currency = key;
      this.getList()
    },
    departmentChange(key) {
      this.department = key;
      this.getList()
    },
    //报销人
    settlementChange(type_id) {
      this.settlement = type_id;
      this.getList()
    },
    //支出大类
    typeChange(key) {
      this.type = key;
      this.getList()
    },
    //支出 小类
    type_chChange(key) {
      this.type_ch = key;
      this.getList()
    },
    //银行
     bankChange(value) {
      this.bank = value;
      this.getList()
    },


    //弹窗的支出小类
    type_ch_oneChange(value){
      this.type_ch_name = value
    },
    //弹窗的支出大类
    type_oneChange(value){
      this.type_name = value
    },

    //结算部门
    department_twoChange(value){
      this.department_two = value
    },
    //发票类型
    invoice_typeChange(value){
      this.invoice_type = value
    },
    //银行
    bank_nameChange(value){
      this.bank_name = value
    },
    settlement_oneChange(value){
      this.settlement_name = value
    },
    currency_oneChange(value){
        this.currency_name = value
    },
    //滑动事件
    imgScrollEvt(e) {
      var e =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        e ||
        document.body.scrollTop;
      //点击分页 滚动条为0
      if (this.pagefenye == true) {
        e.scrollTop = 0;
        this.pagefenye = false
        return
      }
    },
    //列表排序
      sortChangeEvt(row) {
          // 在这里执行你的排序操作
          if (row.order == "descending") {
            this.order = "desc";
            this.orField = row.prop;
          } else if(row.order == "ascending") {
            this.order = "asc";
            this.orField = row.prop;
          } else if (row.order == null) {
            this.order = "";
            this.orField = '';
          }
          this.getList();
    },

    getSummariesEvt(param) {
      const { columns, tableData } = param;
      const sums = [];
      columns.forEach((column, index) => {
        for (let key in this.totalRow) {
          if (column.property == key) {
            sums[index] = this.totalRow[key];
          }
        }
      });
      return sums;
    },


    //获取页面数据
    getList() {
      //入职时间
      let date4 = {
        start: this.value0[0],
        end: this.value0[1],
      };
      //入职时间
      var income_time_start = Math.floor(date4.start / 1000);
      var income_time_end = Math.floor(date4.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate4 = new Date(income_time_end * 1000);
      lastDate4.setHours(23, 59, 59);

      // //离职时间
      income_time_end = Math.floor(lastDate4.getTime() / 1000);
      let date3 = {
        start: this.value1[0],
        end: this.value1[1],
      };
      var end_time_start = Math.floor(date3.start / 1000);
      var end_time_end = Math.floor(date3.end / 1000);

      // // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate3 = new Date(end_time_end * 1000);
      lastDate3.setHours(23, 59, 59);
      end_time_end = Math.floor(lastDate3.getTime() / 1000);


      // //合同到期
      let date1 = {
        start: this.value2[0],
        end: this.value2[1],
      };
      var startTimestamp1 = Math.floor(date1.start / 1000);
      var endTimestamp1 = Math.floor(date1.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate1 = new Date(endTimestamp1 * 1000);
      lastDate1.setHours(23, 59, 59);
      endTimestamp1 = Math.floor(lastDate1.getTime() / 1000);
      this.loading = true;
      let data = {
        orField: this.orField,
        orWhere: this.order,
        page: this.currentPage1,
        limit: this.paginationInput,

        currency:this.currency,
        id: this.id,
        status: this.status,
        settlement: this.settlement,
        bank:this.bank,
        payto_name:this.payto_name,
        remark:this.remark,
        type_ch_name:this.type_ch,
        type_name: this.type,

        department:this.department,
        bm_name: this.bm_name,
        amount: this.amount,
        apply_time: this.apply_time,
        //支出时间
        expend_time_start: end_time_start ? end_time_start : '',
        expend_time_end: end_time_end ? end_time_end : '',

        // //申请时间
        apply_time_start: income_time_start ? income_time_start : '',
        apply_time_end: income_time_end ? income_time_end : '',
        //结算时间
        settlement_time_start: startTimestamp1 ? startTimestamp1 : '',
        settlement_time_end: endTimestamp1 ? endTimestamp1 : '',
      };
      ERPExpApi(data).then((res) => {
        this.tableData = res.data;
        this.total = res.total;
        this.totalRow = res.totalRow;
        this.currentPage1 = res.page - 0;
        this.loading = false
      });

    },
    excelEvt(){
      //入职时间
      let date4 = {
        start: this.value0[0],
        end: this.value0[1],
      };
      //入职时间
      var income_time_start = Math.floor(date4.start / 1000);
      var income_time_end = Math.floor(date4.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate4 = new Date(income_time_end * 1000);
      lastDate4.setHours(23, 59, 59);

      // //离职时间
      income_time_end = Math.floor(lastDate4.getTime() / 1000);
      let date3 = {
        start: this.value1[0],
        end: this.value1[1],
      };
      var end_time_start = Math.floor(date3.start / 1000);
      var end_time_end = Math.floor(date3.end / 1000);

      // // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate3 = new Date(end_time_end * 1000);
      lastDate3.setHours(23, 59, 59);
      end_time_end = Math.floor(lastDate3.getTime() / 1000);


      // //合同到期
      let date1 = {
        start: this.value2[0],
        end: this.value2[1],
      };
      var startTimestamp1 = Math.floor(date1.start / 1000);
      var endTimestamp1 = Math.floor(date1.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate1 = new Date(endTimestamp1 * 1000);
      lastDate1.setHours(23, 59, 59);
      endTimestamp1 = Math.floor(lastDate1.getTime() / 1000);
      let data = {
        orField: this.orField,
        orWhere: this.order,
        page: this.currentPage1,
        limit: this.paginationInput,

        currency: this.currency,
        id: this.id,
        status: this.status,
        settlement: this.settlement,
        bank: this.bank,
        payto_name: this.payto_name,
        remark: this.remark,
        type_ch_name: this.type_ch,
        type_name: this.type,

        department: this.department,
        bm_name: this.bm_name,
        amount: this.amount,
        apply_time: this.apply_time,
        //支出时间
        expend_time_start: end_time_start ? end_time_start : '',
        expend_time_end: end_time_end ? end_time_end : '',

        // //申请时间
        apply_time_start: income_time_start ? income_time_start : '',
        apply_time_end: income_time_end ? income_time_end : '',
        //结算时间
        settlement_time_start: startTimestamp1 ? startTimestamp1 : '',
        settlement_time_end: endTimestamp1 ? endTimestamp1 : '',
        excel: 1,
      };
        let genExcel = false;
        if (genExcel == false) {
          ERPExpApi(data).then((res) => {
            this.loading = false
            window.location.href = res
            genExcel = true
          });
        } else if (genExcel == true) {
          alert('正在生成数据请勿重复请求')
        }
    },
    //清除数据
    cleanUpEvt() {
      this.loading=true
      // 清空其他变量和重置表格数据
      this.value0 = '';
      this.value1 = '';
      this.value2 = '';
      this.currentPage1 = 1;
      this.id = '';
      this.status = '';
      this.settlement = '';
      this.currency ='';
      this.bank = '';
      this.bm_name='';
      this.amount = '';
      this.type = '';
      this.apply_time = '';
      this.payto_name = '';
      this.remark = '';
      this.type_ch = '';
      this.department = '';
      this.$refs.sortTable.clearSort();
      ERPExpApi({
      }).then((res) => {
        this.tableData = res.data;
        this.currentPage1 = res.page - 0;
        this.total = res.total;
        this.totalRow = res.totalRow;
        this.loading=false
      });
    },

  },
  watch: {
    'value0': function (newVal, oldVal) {
      this.isValue3Empty_1 = !newVal;
    },
    'value1': function (newVal, oldVal) {
      this.isValue3Empty_2 = !newVal;
    },
    'value2': function (newVal, oldVal) {
      this.isValue3Empty_3 = !newVal;
    },

  }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import url("../../style/cutomer.less");



/* 固定左侧的项目管理列表 */
.el-aside {
  position: fixed;
  top: 50px;
  /* 顶部Header的高度，根据你的实际Header高度调整 */
  left: 0;
  width: 155px;
  height: 100%;
  /* 使其充满整个可视区域的高度 */
  z-index: 99;
  /* 使其在正文内容之上 */
}

.el-main {
  left: 175px;
  /* 与左侧项目管理列表的宽度保持一致 */
  padding: 0px;
  /* 添加一些内边距，使内容不紧贴在边缘 */
  top: 60px;
  position: relative;
}

/deep/.el-submenu__title {
  height: 39px !important;
  line-height: 39px !important;
  list-style: none;
}


.edit {
  // width: 1000px;
  height: 81px;
  display: flex;

  div {
    width: 137px;
    height: 26px;
    cursor: pointer;
  }

  .el-input {
    width: 137px;
    height: 26px;
    line-height: 26px;
    cursor: pointer;
    width: 137px;
    margin-left: 5px;
  }

  span {
    width: 69px;
    height: 26px;
    font-size: 12px;
    border: 1px solid #589ff9;
    line-height: 26px;
    color: #589ff9;
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /deep/.el-input__inner {
    height: 26px;
    line-height: 26px;
    cursor: pointer;
    font-size: 12px;
    padding-left: 10px;
  }

  /deep/.el-input__icon {
    line-height: 0px;
  }
}

.span_box {
  position: absolute;
  left: 1px;
  top: 85px;
  height: 47px;
  width: 80px;
  background: #fff;
  z-index: 120;
  font-size: 14px;
  line-height: 47px;
  text-align: left;
  padding-left: 13px;
}

/deep/.el-table th.el-table__cell {
  background: #dce6ee;
}

.pagination_box {
  min-width: 500px;
  display: flex;
  // align-items: center;
  justify-content: flex-end;
  position: absolute;
  right: 1px;
  z-index: 123;
  cursor: pointer;
}

/deep/.el-tabs--border-card {
  border: none;
}

/deep/.el-tabs--border-card>.el-tabs__content {
  padding: 0 !important;
}

/deep/.el-table__body-wrapper {
  overflow-y: auto;
}

/deep/.el-table__footer-wrapper {
  position: fixed;
  top: 145px;
  z-index: 111;
  height: 49px;
  background-color: #fff;
  width: calc(100% - 178px);
}

.mainx {
  margin-top: 50px;
}

/deep/.el-table th.el-table__cell {
  background: #f5f7fa;
}

/deep/.el-tabs__header {
  width: 100%;
}

/deep/.el-table__footer-wrapper .gutter {
  background: #f5f7fa;
  border-top: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}

/* 添加一个新的类来将总计行移动到最上方 */
.move-top .el-table__summary-cell {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  /* 根据需要调整背景颜色、字体样式等 */
}

/deep/.el-table__fixed-footer-wrapper {
  display: none;
}

/deep/.el-badge__content.is-fixed {
  display: none;
}

/deep/.el-tabs__item {
  border-radius: 3px 3px 0px 0px;
  background: #d9d9d9;
  margin-left: 4px;
  color: #979797;
  font-size: 12px;
}

/deep/.el-tabs__active-bar {
  display: none;
}

/deep/.el-tabs__item {
  padding: 0;
  width: 105px;
  height: 32px;
  line-height: 32px;
}

/deep/.el-tabs__item.is-active {
  background: #fff;
  border: 1px solid #d9d9d9;
  color: #000;
  border-bottom: none;
}

/deep/.el-table__footer-wrapper tbody td.el-table__cell {
  background: #fff;
  border: none;
}

/deep/ .el-table__footer-wrapper .gutter {
  background: #fff !important;
}

//修改tabs的下划线 以及颜色
/deep/.el-tabs__nav-wrap::after {
  height: 0;
  border: 1px solid #d9d9d9;
}

/deep/.el-tabs__nav {
  transform: translateY(1px) !important;
}

/deep/.el-table th.el-table__cell>.cell {
  color: #333333;
  font-size: 12px;
  height: 23px;

}

/deep/.el-table td.el-table__cell div {
  font-size: 12px;
}

/deep/::placeholder {
  color: #59565a;
  /* 这里替换为你想要的颜色值 */
  margin-left: 5px !important;
}



.maxs {
  background: #f00 !important;
}

/deep/.el-dialog__body {
  padding: 0 !important;
}

/deep/.el-collapse-item {
  width: 490px !important;
}


/deep/.vip .el-input__inner {
  background-color: #bcd9f8d4 !important;
}

//日期选择背景色改变
.your-css-class_box {
  background-color: #bcd9f8d4 !important;
}

//调整下拉选择input
.el-cascader {
  line-height: 25px;
  margin-left: 6px
}

.el-cascader /deep/.el-input__inner {
  height: 27px ;
  min-width: 137px ;
}


//溢出隐藏
.white_over {
  white-space: nowrap;
  overflow: hidden;
}


.whole {
  width: 1090px;
  height: 750px;
  display: flex;
  .banner {
    width: 700px;
    margin-left: 380px;
    height: 835px;
    padding-right: 7px;
  }
}

// 删除和保存的样式
.cloneEvt {
  display: flex;
  height: 24px;
  cursor: pointer;

  span:nth-child(1) {
    display: flex;
    width: 73px;
    padding: 5px 23px;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    background: #3383EA;
    font-size: 12px;
    color: #fff;
    margin-right: 10px;
  }

  span:nth-child(2) {
    display: flex;
    width: 73px;
    padding: 5px 23px;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    background: #979797;
    font-size: 12px;
    color: #fff;
  }
}
/deep/.el-form-item__label{
  font-size:12px;
  padding: 0px;
}
/deep/.el-dialog__header {
  background: #D9D9D9;
}

/deep/.el-dialog__body {
  background: #D9D9D9;
}



.ascending-icon .el-icon-caret-top::before {
  /* 修改升序图标样式 */
  color: red;
}

.descending-icon .el-icon-caret-bottom::before {
  /* 修改降序图标样式 */
  color: blue;
}


/deep/.project_one{
  background: #f4fff8 !important;
}

/deep/.project_two{
  background: #f4f9fd !important;
}

/deep/.project_three{
  background: #fff6dc !important;
}
/deep/.el-table__footer tbody tr .project_one{
  background: #fff !important;
}
/deep/.el-table__footer tbody tr .project_two{
  background: #fff !important;
}

/deep/.el-table__footer tbody tr .project_three{
  background: #fff !important;
}

</style>
<style>
/* 日期选择背景色改变 */

.your-css-class_box .el-range-input {
  background-color: #8fc6ff00 !important;
}

/* 日期选择 第四个位置间距拉开 */
.el-picker-panel__sidebar button:nth-child(4) {
  margin-bottom: 30px;
}

.el-tooltip__popper.is-dark {
  background-color: #589ff9 !important;
}

.el-tooltip__popper .popper__arrow {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/src/Expenditure_management/index.vue